import * as React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { ImagesContext } from "../../Context";
import { PatientType } from "../types";
import moment from "moment";

interface PatientInfoProps {
  patient: PatientType | null;
  handleSetEditing: () => void;
  claimStatus: string;
}

const PatientInfo: React.FC<PatientInfoProps> = ({
  patient,
  handleSetEditing,
  claimStatus,
}) => {
  const images = React.useContext(ImagesContext);

  return (
    <Box className="info-container">
      <Grid container>
        <Grid item xs={3}>
          <Typography className="info-heading-label">
            Name (Last, First, Middle)
          </Typography>
          <Typography className="info-heading-text">
            {patient?.last_name}
            <br />
            {patient?.first_name}
            <br />
            {patient?.middle_name}
          </Typography>
        </Grid>

        <Grid item xs={2}>
          <Typography className="info-heading-label">Address</Typography>
          <Typography className="info-heading-text">
            <>
              {patient?.address_line_1}{" "}
              {patient?.address_line_2 && `, ${patient?.address_line_2}`}
              <br />
              {patient?.city}
              {patient?.city && ","} {patient?.state} {patient?.zip}
              {patient?.zipExtension && `-${patient?.zipExtension}`}
              <br />
            </>
          </Typography>
        </Grid>

        <Grid item xs={2}>
          <Typography className="info-heading-label">Demographics</Typography>
          <Typography className="info-heading-text">
            <>
              DOB: {moment(patient?.date_of_birth).format("MM/DD/YYYY")}
              <br />
              Sex: {patient?.gender}
              <br />
              Phone: {patient?.mobile_phone_number}
            </>
          </Typography>
        </Grid>
        {claimStatus !== "submitted" &&
          claimStatus !== "pending_submission" && (
            <Grid item xs={5} display="flex" justifyContent="flex-end">
              <div className="item-icon-container" onClick={handleSetEditing}>
                <img
                  src={images.pencil_orange_icon}
                  alt="edit patient Icon"
                  className="action-icon-image"
                  style={{ width: 23, maxHeight: 23 }}
                />
              </div>
            </Grid>
          )}
      </Grid>
    </Box>
  );
};

export default PatientInfo;
